import API from "@/api"

//上传配置

export default {
  apiObj: API.common.upload, //上传请求API对象
  secureApiObj: API.common.uploadSecureFile, //附件加密上传请求API对象
  filename: "file", //form请求时文件的key
  successCode: 200, //请求完成代码
  maxSize: 5, //最大文件大小 默认10MB
  parseData: function (res) {
    console.log(11, res)
    if (!res) {
      return res
    }
    return {
      code: res.code, //分析状态字段结构
      fileName: res.data.fileName, //分析文件名称
      src: res.data.src, //分析图片远程地址结构
      value: "/file/" + res.data.fileName,
      msg: res.message //分析描述字段结构
    }
  },
  parseSecureData: function (res) {
    if (!res) {
      return res
    }
    return {
      code: res.code, //分析状态字段结构
      src: res.data.viewUrl, //分析文件名称
      value: res.data.viewUrl
    }
  },
  apiObjFile: API.common.uploadFile, //附件上传请求API对象
  secureApiObjFile: API.common.uploadSecureFile, //附件加密上传请求API对象
  maxSizeFile: 10 //最大文件大小 默认10MB
}
